<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="查询年度">
              <a-select placeholder="请选择" v-model="queryParam.queryMonth">
                <a-select-option v-for="(item,index) in queryYears" :value="item.val" :key="index">
                  {{item.text}}
                </a-select-option>           
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <span style="margin-right: 60px;">币别：{{fcurrencyName}}</span>
        <span style="float:right; ">金额单位：万元</span>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="departSlot" slot-scope="depart">
          <span v-if="depart.level===1">{{depart.text}}</span>
          <span v-else style="margin-left:45px;">{{depart.text}}</span>
        </template>
      </a-table>

    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction } from '@/api/manage'

  export default {
    name: 'BizOperationMonthReport',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        description: '运营年度报表',
        disableMixinCreated: true,
        fcurrencyName:'人民币',
        queryYears:[], // 可查询年度
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'部门',
            className: 'column-text',
            dataIndex: 'departName',
            scopedSlots: {customRender: 'departSlot'}
          },
        ],
        url: {
          list: "/bms/operateReport/getOperateReport2022",
        },
      }
    },
    created() {
      // 初始化查询年度      
      this.queryYears.push({val: 2022, text: '2022年'})      

      // 初始化表头
      this.getBusinessProject()
    },
    methods: {
      getBusinessProject(){
        let businessTypes = [
          {businessTypeNumber_dictText:'运维', businessTypeShort:'YW'},
          {businessTypeNumber_dictText:'直拓', businessTypeShort:'ZT'},
          {businessTypeNumber_dictText:'长期寿险', businessTypeShort:'CQ'},
          {businessTypeNumber_dictText:'综拓', businessTypeShort:'ZOT'}];
        this.initTableHeader(businessTypes)
      },
      initTableHeader(businessType){
        if(businessType){
          // 加载表头数据
          for(let i=0; i<businessType.length; i++){
            let typeColumn = {
              title: businessType[i].businessTypeNumber_dictText + '业务',
              children:[
                {
                  title:'净保费',
                  className: 'column-money',
                  dataIndex: businessType[i].businessTypeShort + 'JBF'
                },
                {
                  title:'净佣金',
                  className: 'column-money',
                  dataIndex: businessType[i].businessTypeShort + 'JYJ'
                },
                {
                  title:'到账净佣金',
                  className: 'column-money',
                  dataIndex: businessType[i].businessTypeShort + 'DZJYJ'
                },
              ]
            }
            this.columns.push(typeColumn)
          }
          let typeColumn = {
            title: '总计',
            children:[
              {
                title:'净保费',
                className: 'column-money',
                dataIndex: 'ZONJIJBF',
                customRender: function(text) {
                  return !text ? '': text.toLocaleString();
                }
              },
              {
                title:'净佣金',
                className: 'column-money',
                dataIndex: 'ZONJIJYJ',
                customRender: function(text) {
                  return !text ? '': text.toLocaleString();
                }
              },
              {
                title:'到账净佣金',
                className: 'column-money',
                dataIndex: 'ZONJIDZJYJ',
                customRender: function(text) {
                  return !text ? '': text.toLocaleString();
                }
              }
            ]}
          this.columns.push(typeColumn)
          return true;
        } else {
          this.$message.warning("没有获取到业务类型字典数据，请重新登录！")
          return false
        }
      },

      loadData() {
        this.loading = true;

        let startDate = "2022-01-01"
        let endDate = "2022-12-31";
        let param = {startTime:startDate, endTime: endDate}

        getAction(this.url.list, param).then((res) => {
          if (res.success) {
            this.dataSource = this.transferData(res.result);
          }
          if (res.code === 510) {
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },

      // 把后台返回数据进行格式转换
      transferData(resultData){
        if(!resultData){
          return;
        }

        // 顺序是确定的, level是报表中的级次，第一个子公司也是一级
        let departAndProject = [{text:'翔胜巴',level:1},{text:'盛泰巴',level:1},{text:'创新巴',level:1},
          {text:'其中：山钢集团',level:1},
          {text:'鲁商集团',level:2},{text:'青岛机场',level:2},
          {text:'烟台机场',level:2},{text:'久泰能源',level:2},{text:'政府采购',level:2},{text:'齐鲁干细胞',level:2},{text:'其他',level:2},
          {text:'汇金巴',level:1},{text:'其中：商河营业部',level:1},{text:'邹平营业部',level:2},{text:'淄博分公司',level:2},{text:'德州分公司',level:2},{text:'博兴营业部',level:2},{text:'烟台分公司',level:2},
          {text:'枣庄分公司',level:2},{text:'滨城营业部',level:2},{text:'滨北营业部',level:2},{text:'内蒙古分公司',level:2},{text:'乐陵分公司',level:2},{text:'临沂分公司',level:2},{text:'青岛分公司',level:2},
          {text:'安能巴',level:1},{text:'其中：山东能源',level:1},{text:'泰安校责险',level:2},{text:'久泰能源(安能)',level:2},{text:'齐鲁干细胞(安能)',level:2},{text:'其他(安能)',level:2},
          {text:'创业赋能与运营管理部',level:1},{text:'企划督导与人才优化部',level:1},{text:'经营核算与财务投资部',level:1},{text:'综合事务部',level:1},{text:'合计',level:1}];

        let resData = [];
        let index = 1;
        for(let i=0; i<departAndProject.length; i++){ //按数组的顺序添加
          if(resultData[departAndProject[i].text]){
            let data = this.getDepartmentOrProjectData(departAndProject[i], resultData, index);
            resData.push(data);
            index++;
          }
        }
        return resData;
      },

      getDepartmentOrProjectData(departOrProject, resultData, index){
        let data = resultData[departOrProject.text];
        let YWJBF = 0.0, YWJYJ = 0.0, YWDZJYJ=0.0, ZTJBF = 0.0, ZTJYJ = 0.0, ZTDZJYJ=0.0,
          ZOTJBF = 0.0, ZOTJYJ = 0.0, ZOTDZJYJ=0.0,CQJBF = 0.0, CQJYJ = 0.0, CQDZJYJ=0.0,
          ZONJIJBF = 0.0, ZONJIJYJ = 0.0, ZONJIDZJYJ=0.0;
        if(data['YW']){ //运维
          YWJBF = data['YW']['cleanPremium']
          YWJYJ = data['YW']['cleanBrokerage']
          YWDZJYJ = data['YW']['payCleanBrokerage']
        }
        if(data['ZT']){ //直拓
          ZTJBF = data['ZT']['cleanPremium']
          ZTJYJ = data['ZT']['cleanBrokerage']
          ZTDZJYJ = data['ZT']['payCleanBrokerage']
        }
        if(data['ZOT']){ //综拓
          ZOTJBF = data['ZOT']['cleanPremium']
          ZOTJYJ = data['ZOT']['cleanBrokerage']
          ZOTDZJYJ = data['ZOT']['payCleanBrokerage']
        }
        if(data['CQ']){// 长期寿险
          CQJBF = data['CQ']['cleanPremium']
          CQJYJ = data['CQ']['cleanBrokerage']
          CQDZJYJ = data['CQ']['payCleanBrokerage']
        }
        if(data['ZONJI']){ // 行总计
          ZONJIJBF = data['ZONJI']['cleanPremium']
          ZONJIJYJ = data['ZONJI']['cleanBrokerage']
          ZONJIDZJYJ = data['ZONJI']['payCleanBrokerage']
        }

        return {id: index, departName : departOrProject,
          YWJBF:YWJBF,YWJYJ:YWJYJ, YWDZJYJ:YWDZJYJ, ZTJBF:ZTJBF, ZTJYJ:ZTJYJ, ZTDZJYJ:ZTDZJYJ,
          ZOTJBF:ZOTJBF, ZOTJYJ:ZOTJYJ , ZOTDZJYJ:ZOTDZJYJ,CQJBF:CQJBF, CQJYJ:CQJYJ, CQDZJYJ:CQDZJYJ,
          ZONJIJBF:ZONJIJBF, ZONJIJYJ:ZONJIJYJ, ZONJIDZJYJ:ZONJIDZJYJ}
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
